import type { FC } from "react";

import { ContactBlock as UIContactBlock } from "@jti/ui/components/ContactBlock";

import type { contactBlockInputs } from "./ContactBlock.builder";

type ContactBlockBuilderProps = BuilderComponentProps<typeof contactBlockInputs>;

export const ContactBlock: FC<ContactBlockBuilderProps> = ({ layout, contactBlocks }) => {
  return <UIContactBlock layout={layout} contactBlocks={contactBlocks} />;
};
